import { render, staticRenderFns } from "./AdditionalInfo.vue?vue&type=template&id=66fb3820&scoped=true"
import script from "./AdditionalInfo.vue?vue&type=script&lang=js"
export * from "./AdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb3820",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fb3820')) {
      api.createRecord('66fb3820', component.options)
    } else {
      api.reload('66fb3820', component.options)
    }
    module.hot.accept("./AdditionalInfo.vue?vue&type=template&id=66fb3820&scoped=true", function () {
      api.rerender('66fb3820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/components/AdditionalInfo.vue"
export default component.exports